import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, Auth, connectAuthEmulator } from "firebase/auth";
import {
  getFirestore,
  Firestore,
  connectFirestoreEmulator,
} from "firebase/firestore";
import {
  getStorage,
  FirebaseStorage,
  connectStorageEmulator,
} from "firebase/storage";

import { env } from "../config/env";

// Initialize Firebase (singleton pattern)
let app: FirebaseApp;
if (getApps().length === 0) {
  app = initializeApp(env.firebase);
} else {
  app = getApps()[0]!;
}

// Determine environment and emulator usage
const environment = import.meta.env.VITE_ENVIRONMENT || "production";
const useEmulator = environment === "local";

// Dynamic bucket selection for storage
// In local environment, use the default bucket name (Firebase uses .appspot.com for emulators)
// In other environments (dev, staging, prod), use the bucket from env config
const storageBucket = useEmulator
  ? "gs://apaato-local.appspot.com" // Match emulator's default bucket naming
  : `gs://${env.firebase.storageBucket}`; // Use bucket from .env

// Initialize services
export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app, storageBucket);

// Connect to emulators in local environment only
// Other environments (dev, staging, prod) use real Firebase projects
if (useEmulator) {
  // Auth Emulator (port from firebase.json)
  connectAuthEmulator(auth, "http://127.0.0.1:9099", {
    disableWarnings: true,
  });

  // Firestore Emulator (port from firebase.json)
  connectFirestoreEmulator(db, "127.0.0.1", 8080);

  // Storage Emulator (default port)
  // IMPORTANT: Connect AFTER getStorage() with explicit bucket
  connectStorageEmulator(storage, "127.0.0.1", 9199);

  console.log("🔧 Firebase Emulators connected (local environment):");
  console.log("  • Auth: http://127.0.0.1:9099");
  console.log("  • Firestore: http://127.0.0.1:8080");
  console.log("  • Storage: http://127.0.0.1:9199");
  console.log("  • UI: http://127.0.0.1:4000");
  console.log(`📦 Storage Bucket: ${storage.app.options.storageBucket}`);
} else {
  console.log(
    `🔥 Firebase connected to real project: ${env.firebase.projectId} (${environment})`,
  );
  console.log(`📦 Storage Bucket: ${storage.app.options.storageBucket}`);
}

export default app;
